import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

export const useApiError = () => {
  const { autoLogout } = useAuth();

  const handleError = useCallback((error, customMessage = null) => {
    console.error('Erro na API:', error);

    // Se for erro 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      autoLogout('Token inválido ou expirado');
      return;
    }

    // Se for erro 403 (Forbidden)
    if (error.response && error.response.status === 403) {
      toast.error('Acesso negado');
      return;
    }

    // Se for erro de rede
    if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CONNECTION_REFUSED') {
      toast.error('Erro de conexão com o servidor');
      return;
    }

    // Se for timeout
    if (error.code === 'ECONNABORTED') {
      toast.error('Timeout na requisição');
      return;
    }

    // Outros erros
    const message = customMessage || 
                   error.response?.data?.message || 
                   error.message || 
                   'Erro inesperado';
    
    toast.error(message);
  }, [autoLogout]);

  return { handleError };
}; 